import { c as _c } from "react/compiler-runtime";
import { useHasBeenInViewport } from "common/hooks/interaction/useHasBeenInViewport";
import { isYouTubeUrl, normalizeUrl, thumbnailUrl } from "common/lib/youtube";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
export interface VideoProps {
  /** Video source URL. */
  src: string;
  /** Caption for the video. */
  caption?: string;
  /** Disable user interaction for the video. */
  disable?: boolean;
}
export const Video = t0 => {
  "use memo";

  const $ = _c(11);
  const {
    src,
    caption,
    disable
  } = t0;
  const t = useTranslations("blocks.video");
  const {
    setRef,
    hasBeenInViewport
  } = useHasBeenInViewport(100);
  let t1;
  if ($[0] !== disable || $[1] !== src || $[2] !== t) {
    t1 = disable ? <img src={thumbnailUrl(src, "hq")} alt={t("youtube_thumbnail_label")} className="w-full" /> : <iframe className="aspect-video w-full" src={normalizeUrl(src)} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} title={t("youtube_label")} />;
    $[0] = disable;
    $[1] = src;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const youtubeVideo = t1;
  let t2;
  if ($[4] !== caption || $[5] !== hasBeenInViewport || $[6] !== setRef || $[7] !== src || $[8] !== t || $[9] !== youtubeVideo) {
    t2 = isYouTubeUrl(src) ? <figure data-testid="youtube-figure" className="my-4 aspect-video max-w-(--breakpoint-lg) lg:my-9" ref={setRef}><div className="bg-black">{hasBeenInViewport && youtubeVideo}</div>{caption && <figcaption className="mt-1 text-sm text-gray-700">{caption}</figcaption>}</figure> : <figure className="my-4 max-w-(--breakpoint-lg) lg:my-9"><video src={src} data-testid="video-player" controls={true} className="w-full" aria-label={t("generic_label")} />{caption && <figcaption className="mt-1 text-sm text-gray-700">{caption}</figcaption>}</figure>;
    $[4] = caption;
    $[5] = hasBeenInViewport;
    $[6] = setRef;
    $[7] = src;
    $[8] = t;
    $[9] = youtubeVideo;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};